import { IColumnSetting } from '@aqx-core/common/api/user-account-setting';
import { compareArrays } from '@aqx-core/common/utils/array';

export const compareColumnSettings = (newColumnSettings: IColumnSetting[], defaultColumnSettings: IColumnSetting[]) => {
  return compareArrays(newColumnSettings, defaultColumnSettings, ['label', 'visible']);
};
